import ky from 'ky';
import { clearToken, getJwtToken } from '@/lib/hooks/useSession';
import { getRequestLanguage } from '@/components/common/ClientProvider';
import { localeMap } from '@/lib/config/locale';
import { fallbackLng, Language } from '@/i18n/settings';
import { getWorkerHttpUrl } from '@/lib/utils/client.utils';

export function getAiApiUrl() {
  return process.env.NEXT_PUBLIC_AI_REQUEST_URL || 'https://test-dex-api.heima.network/ai-analyze'
}

export interface ResponseMap<T> {
  data?: T;
  message: string;
  code: number;
}

export interface ResponseMap<T> {
  data?: T;
  status: string;
}
export const api = ky.extend({
  timeout: 20000,
  hooks: {
    beforeRequest: [
      (request) => {
        const session = getJwtToken();
        const language = getRequestLanguage();
        if (session) {
          request.headers.set(
            'Authorization',
            `Bearer ${session.accessToken ?? ''}`,
          );
        }
        request.headers.set('X-Language', localeMap[language]);
      },
    ],
    beforeError: [
      (error) => {
        const token = getJwtToken();
        if (error.response.status === 401 && token?.accessToken) {
          clearToken();
          window.location.reload();
        }
        return error;
      },
    ],
  },
});
export const staticDataApi = (language: Language) => {
  const locale = localeMap[language] ?? localeMap[fallbackLng];
  return ky.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set('X-Language', locale);
        },
      ],
      beforeError: [],
    },
  });
};
type JsonRpcRequest<T = any> = {
  jsonrpc: '2.0';
  method: string;
  id: number;
  params: T;
};
type JsonRpcResponse<T = any> = {
  jsonrpc: '2.0';
  id: number;
  result: T;
};
type JsonRpcError = {
  jsonrpc: '2.0';
  id: number;
  error: {
    code: number;
    message: string;
  };
};
export const workerRequestApi = async <Req = any, Res = any>(
  method: string,
  payload: Req,
  _token?: string,
) => {
  const sessionToken = getJwtToken();
  const token = _token ?? sessionToken?.idToken;
  const response = await ky.post(getWorkerHttpUrl(), {
    json: {
      jsonrpc: '2.0',
      method: method,
      id: 1,
      params: payload,
    },
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
  if (!response.ok) {
    const res = await response.json<JsonRpcError>();
    if (response.status === 401 && sessionToken?.idToken) {
      clearToken();
      window.location.reload();
    }
    throw new Error(res.error.message);
  }
  return await response.json<JsonRpcResponse<Res>>();
};
